module.exports = {
      id: "icon-appstore-usage",
      viewBox: "0 0 189.408 63.551",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#icon-appstore",
      toString: function () {
        return this.url;
      }
    }